import React from "react";
import { useTable, useFilters, usePagination, useExpanded } from "react-table";
import "./styles.scss";
import notFound from "assets/images/notFound.png";
import { useTranslation } from "react-i18next";
import CustomPagination from "common/components/Pagination/CustomPagination";
import { tableColumns } from "components/ControlCenterReports/types";

type Props = {
  data: any[];
  columns: tableColumns[];
  pageIndex: number;
  pageCount: number;
  setPageIndex: React.Dispatch<React.SetStateAction<number>>;
};

const PAGE_SIZE = 20;

const ReactTable = ({
  data,
  columns,
  pageIndex,
  setPageIndex,
  pageCount,
}: Props) => {
  const { t } = useTranslation();
  const { getTableProps, getTableBodyProps, headerGroups, prepareRow, page } =
    useTable(
      {
        columns,
        data,
        initialState: { pageIndex: 0, pageSize: PAGE_SIZE },
      },
      useFilters,
      useExpanded,
      usePagination
    );

  return data.length > 0 ? (
    <>
      <div className="table-container">
        <table {...getTableProps()}>
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <th {...column.getHeaderProps()}>
                    <div>{column.render("Header")}</div>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.map((row) => {
              prepareRow(row);
              return (
                <React.Fragment key={row.index}>
                  <tr {...row.getRowProps()}>
                    {row.cells.map((cell) => {
                      return (
                        <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                      );
                    })}
                  </tr>
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
      </div>
      {pageCount > 1 && (
        <div className="table-pagination">
          <CustomPagination
            totalPages={pageCount}
            activePage={pageIndex}
            onPageChange={setPageIndex}
          />
        </div>
      )}
    </>
  ) : (
    <div className="not-found-container">
      <img src={notFound} alt="Logo" />
      <div>{t("noTableData")}</div>
    </div>
  );
};

export default ReactTable;
